import { reatomAsync, withDataAtom } from "@reatom/async";
import { API } from "src/api";
import { withIsLoadingAtom } from "src/common/pipes";

export const getUser = reatomAsync(
  async (ctx, { userId }: { userId: string }) => {
    return API.userApi
      .userControllerGetUserById(userId)
      .then((response) => response.data);
  },
  "getUserRequest",
).pipe(withDataAtom(null), withIsLoadingAtom());
